import { connect } from 'react-redux';
import { activeBreadCrumbContext, activeBreadcrumbForDb } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import { hitSetKey } from '@Selectors/StateParamsSelectors';
import { recordCountOrTotalResult } from '@Containers/PatentFamilyClustering/selectors';
import { editInQueryBuilder, saveSearch } from '@Containers/ResultToolbar/ResultToolbarActions';
import { dispatchCreateAlert } from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogActions';
import {
  isTgitemsContext,
  isReactionsContext,
  isCitationsContext,
  isSubstancesContext,
  availableRelativeContext,
} from '@Containers/ResultToolbar/ResultToolbarSelectors';
import ResultTopPanel from './ResultTopPanel';

function mapStateToProps(state) {
  return {
    activeBreadCrumb: activeBreadcrumbForDb(state),
    activeBreadCrumbContext: activeBreadCrumbContext(state),
    totalResult: recordCountOrTotalResult(state),
    isTgitemsContext: isTgitemsContext(state),
    isReactionsContext: isReactionsContext(state),
    isCitationsContext: isCitationsContext(state),
    isSubstancesContext: isSubstancesContext(state),
    availableRelativeContext: availableRelativeContext(state, { hitSetKey: hitSetKey(state) }),
  };
}

const mapDispatchToProps = {
  saveSearch,
  editInQueryBuilder,
  dispatchCreateAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultTopPanel);
